import { apiClient } from './api';

export interface RegisterCustomerPayload {
  name: string;
  cpf: string;
  email: string;
  phone: string;
  birthDate: string;
  state: string;
  city: string;
  consentLgpd: boolean;
  consentTerms: boolean;
  consentNotifications: boolean;
}

export interface Customer {
  id: string;
  name: string;
  cpf: string;
  email: string;
}

export const customerService = {
  register: async (payload: RegisterCustomerPayload): Promise<Customer> => {
    const { data } = await apiClient.post<Customer>('/customer/auth/register', payload);
    return data;
  },
};